import React from 'react';
import {
  InternalLayout,
  InternalLayoutProvider,
} from 'volto-ministerio-publico-federal/components/Layouts';
import { Attachments } from 'volto-ministerio-publico-federal/components/Attachments';
import { hasSignificantBlocks } from 'volto-ministerio-publico-federal/utils/hasSignificantBlocks';
import { RenderBlocksWithoutTitle } from '../InternalView/RenderBlocksWithoutTitle';
import { MPFAlert } from 'volto-ministerio-publico-federal/components/UI/Alert';

interface Content {
  [key: string]: unknown;
  title?: string;
  description?: string;
  /** "Ocultar título" (behavior `ministerio.publico.federal.ocultar_titulo`). */
  ocultar_titulo?: boolean;
  items?: Array<{ '@type': string; [key: string]: unknown }>;
  relatedItems?: Array<{ '@id': string; title: string }>;
  blocks?: Record<string, unknown>;
  blocks_layout?: { items?: string[] };
}

interface FilesViewProps {
  content: Content;
}

const FilesView: React.FC<FilesViewProps> = ({ content }) => {
  if (!content) return null;

  const fileItems = (content.items || []).filter(
    (item) => item['@type'] === 'File',
  );
  const hasFiles = fileItems.length > 0;

  const hasBlocks = hasSignificantBlocks(
    content.blocks,
    content.blocks_layout as { items?: string[] },
  );

  const mainContent = (
    <>
      {hasBlocks && <RenderBlocksWithoutTitle content={content} />}
      {hasFiles && <Attachments items={fileItems} />}
      {!hasFiles && (
        <MPFAlert
          type="warning"
          message="Nenhum arquivo encontrado nesta pasta."
        />
      )}
    </>
  );

  return (
    <InternalLayoutProvider
      title={content.title ?? ''}
      description={content.description}
      relatedItems={content.relatedItems}
      ocultarTitulo={content.ocultar_titulo}
      reviewState={content.review_state as string | undefined}
    >
      <InternalLayout>{mainContent}</InternalLayout>
    </InternalLayoutProvider>
  );
};

export default FilesView;
